export default "__VITE_ASSET__547165bd__"